module.exports = __webpack_public_path__ + "media/svg/Book-f43786ba.svg";